import request from '@/utils/request'

/**
 * POST 方法 与 GET方法  区别
 *
 * post==> data: obj
 * get==>params: obj
 *
 */
 export function postUserInfo(obj:any) {
   return request({
    headers:{
      'Content-Type':'application/x-www-form-urlencoded',
      // 'Accept':'application/x-www-form-urlencoded'
     },
     url: '/login',      
     method: 'post',
     data: obj,    
   })
 }
 export function yzmLogin(obj:any) {
  return request({
    url: '/userRegByPhoneHryApp',      
    method: 'get',
    params: obj,    
  })
}
export function getYzm(obj:any) {
  return request({
    url: '/userPullValidCode',      
    method: 'get',
    params: obj,    
  })
}
//用户信息
export function getUserInfo(obj:any) {
  return request({
    url: '/user/miniAppUcenterMyInforApi',      
    method: 'get',
    params: obj,    
  })
}
